import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import MyCompLeaveReqs from '../components/MyCompLeaveReqs';
import NavBar from '../components/Menu/NavBar'
import { pageStyle } from '../components/UIComponent/CommonStyle'
import { setLocalStorageSettings } from '../components/Function/globalFunction';

const useStyles = makeStyles(() => ({
    ...pageStyle()
}));

export default function MyCompLeaveReqsPage({ routing, routingId }) {
    const classes = useStyles();
    setLocalStorageSettings({
        'selectedIndex': 4,
        'isMyRequestOpen': 'true',
        'isApplicationOpen': 'false',
        'isLeaveApprovalOpen': 'false',
        'isHRAdminOpen': 'false'
    });

    return (
        <div className={classes.root}>
            <CssBaseline />
            <NavBar />
            <MyCompLeaveReqs routing={routing} routingId={routingId} />
        </div>
    )
}